import { ref, type Ref } from 'vue';

/**
 * Vue `ref` on the client; plain `{ value }` box on the server.
 *
 * Module-level refs are process singletons. During SSR every request that
 * tracks them adds Vue `Link`/`Dep` edges that are never GC'd with the request
 * tree — heap snapshots showed Link/Dep doubling under load. Use this for
 * process-global signals that only need reactivity in the browser.
 */
export function clientOnlyRef<T>(initial: T): Ref<T> {
  if (import.meta.client) {
    return ref(initial) as Ref<T>;
  }

  return { value: initial } as Ref<T>;
}
